import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';

var debounce = function debounce(func, wait) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var timeout;

  var debounced = function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this;

    var later = function later() {
      timeout = null;
      if (!options.immediate) func.apply(context, args);
    };

    var callNow = options.immediate && !timeout;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };

  debounced.cancel = function () {
    if (timeout) clearTimeout(timeout);
    timeout = null;
  };

  return debounced;
};

var DebounceMap = /*#__PURE__*/function () {
  function DebounceMap() {
    _classCallCheck(this, DebounceMap);

    _defineProperty(this, "_config", {});

    _defineProperty(this, "_debounces", {});
  }

  _createClass(DebounceMap, [{
    key: "_registerDebounce",
    value: function _registerDebounce(key) {
      var timeout;
      var config = this._config;
      return function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var context = this;
        var options = config[key].options || {};

        var later = function later() {
          timeout = null;

          if (!options.immediate) {
            config[key].func.apply(context, args);
          }
        };

        var callNow = options.immediate && !timeout;
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(later, config[key].wait);
        if (callNow) config[key].func.apply(context, args);
      };
    }
  }, {
    key: "debounce",
    value: function debounce(key, func, wait) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      this._config[key] = {
        func: func,
        wait: wait,
        options: options
      };

      if (!this._debounces[key]) {
        this._debounces[key] = this._registerDebounce(key);
      }

      this._debounces[key]();
    }
  }]);

  return DebounceMap;
}();

export { DebounceMap, debounce };
